import { Footer, Navbar, TvShowsDetails } from "../components";

const TvShowsDetailsPage = () => {
  return (
    <div>
      <Navbar />
      <TvShowsDetails />
      <Footer />
    </div>
  );
};

export default TvShowsDetailsPage;
